import loadDataIntoLocalStorage from './load-data'

export default loadDataIntoLocalStorage
